// API base: production default; override with REACT_APP_API_URL (e.g. http://localhost:3000 for local)
// let workapi =
//   process.env.REACT_APP_API_URL || "https://api.kooliapp.in";

  let workapi =
  process.env.REACT_APP_API_URL || "http://localhost:3001";


let workerRegister=workapi+'/server/user/register/'

let workerLogin=workapi+'/server/user/login'

let workerauth=workapi+'/server/authenticate/worker'

let providerauth=workapi+'/server/authenticate/provider'

let workerotp=workapi+'/server/user/verifyOtp'

let workProfileupload=workapi+'/api/worker/setProfile'

let workerprofileget=workapi+'/api/worker/getprofile'

let workerWorkGet=workapi+'/server/worker/getWork'

let locationAll=workapi+'/server/location'

let workerjobadd=workapi+'/api/worker/addjobs'

let workerjobclear=workapi+'/api/worker/clearjobs'

let workerAddress=workapi+'/api/worker/address'

let Allwork=workapi+'/server/worker/getAllWork'

let purchase=workapi+'/server/provider/purchase'

let userWork=workapi+'/server/worker/createWork'

let verifyAddress=workapi+'/api/worker/verifyAddress'

let verifyPayment=workapi+'/server/provider/verifyPay'

let providerJobAdd=workapi+'/server/provider/addJob'

// Worker job flow APIs
let workerGetJobs=workapi+'/server/worker/getJobs'
let workerJobPurchase=workapi+'/server/worker/job/purchase'
let workerJobVerifyPay=workapi+'/server/worker/job/verifyPay'

// Wallet + Request APIs
let walletBalance=workapi+'/server/wallet/balance'
let walletTransactions=workapi+'/server/wallet/transactions'
let walletRecharge=workapi+'/server/wallet/recharge'
let walletVerify=workapi+'/server/wallet/verify'
let requestSend=workapi+'/server/request/send'
let requestIncoming=workapi+'/server/request/incoming'
let requestOutgoing=workapi+'/server/request/outgoing'
let requestAccept=(id)=>workapi+`/server/request/${id}/accept`
let requestReject=(id)=>workapi+`/server/request/${id}/reject`
let requestCancel=(id)=>workapi+`/server/request/${id}/cancel`

let worker_register=workapi+'/api/worker/register-provider'
 
let worke_provider_login=workapi+'/api/worker/login-provider'


let deleteWork=workapi+'/server/worker/deleteWork'

let workersListBylocation=workapi+'/server/provider/getworker'

let forgotPasswordApi=workapi+'/server/user/forgetPassword'

let verifyOtpApi=workapi+'/server/user/updatePassword'
module.exports={
    workerRegister,
    workerLogin,
    workerauth,
    workerotp,
    workProfileupload,
    workerprofileget,
    workerjobadd,
    workerjobclear,
    workerAddress,
    Allwork,
    userWork,
    verifyAddress,
    verifyPayment,
    worker_register,
    worke_provider_login,
    workerWorkGet,
    locationAll,
    deleteWork,
    workersListBylocation,
    purchase,
    forgotPasswordApi,
    verifyOtpApi,
    providerauth,
    providerJobAdd,
    workerGetJobs,
    workerJobPurchase,
    workerJobVerifyPay,
    walletBalance,
    walletTransactions,
    walletRecharge,
    walletVerify,
    requestSend,
    requestIncoming,
    requestOutgoing,
    requestAccept,
    requestReject,
    requestCancel,
}
